export const isCtrlKey = (e: KeyboardEvent) => {
    return e.metaKey || e.ctrlKey;
};

export const isShiftKey = (e: KeyboardEvent) => {
    return e.shiftKey;
};

export const isOptionAltKey = (e: KeyboardEvent) => e.altKey;
